const menuButton = document.querySelectorAll(".js-trigger-menu");
const menuItem = document.querySelectorAll(".menu-item a");
const body = document.querySelector("body");

menuButton.forEach((element) => {
  element.addEventListener("click", (event) => {
    body.classList.toggle("is-menu-active");
  });
});

menuItem.forEach((element) => {
  element.addEventListener("click", (event) => {
    if (body.classList.contains("is-menu-active")) {
      body.classList.remove("is-menu-active");
    }
  });
});
